"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftViewDto = instanceOfShiftViewDto;
exports.ShiftViewDtoFromJSON = ShiftViewDtoFromJSON;
exports.ShiftViewDtoFromJSONTyped = ShiftViewDtoFromJSONTyped;
exports.ShiftViewDtoToJSON = ShiftViewDtoToJSON;
exports.ShiftViewDtoToJSONTyped = ShiftViewDtoToJSONTyped;
const ShiftViewedByNurseSource_1 = require("./ShiftViewedByNurseSource");
/**
 * Check if a given object implements the ShiftViewDto interface.
 */
function instanceOfShiftViewDto(value) {
    if (!('timestamp' in value) || value['timestamp'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
function ShiftViewDtoFromJSON(json) {
    return ShiftViewDtoFromJSONTyped(json, false);
}
function ShiftViewDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timestamp': (new Date(json['timestamp'])),
        'source': (0, ShiftViewedByNurseSource_1.ShiftViewedByNurseSourceFromJSON)(json['source']),
    };
}
function ShiftViewDtoToJSON(json) {
    return ShiftViewDtoToJSONTyped(json, false);
}
function ShiftViewDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'timestamp': ((value['timestamp']).toISOString()),
        'source': (0, ShiftViewedByNurseSource_1.ShiftViewedByNurseSourceToJSON)(value['source']),
    };
}
//# sourceMappingURL=ShiftViewDto.js.map